module.exports = __webpack_public_path__ + "img/folder.7668f6bb.svg";